module.exports = __webpack_public_path__ + "static/media/AiSparkles.47d2a274.png";